import { useState } from 'react';

const WhatsAppButton = () => {
  const [hoveredWa, setHoveredWa] = useState(false);
  const [hoveredMail, setHoveredMail] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Email Button */}
      <div className="flex items-center gap-3">
        {hoveredMail && (
          <div className="bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-full shadow-lg whitespace-nowrap">
            contacto@ingemetalsur.cl
          </div>
        )}
        <a
          href="mailto:contacto@ingemetalsur.cl"
          rel="nofollow noopener noreferrer"
          className="w-14 h-14 bg-white rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-200 cursor-pointer border border-gray-200"
          onMouseEnter={() => setHoveredMail(true)}
          onMouseLeave={() => setHoveredMail(false)}
          aria-label="Enviar correo a contacto@ingemetalsur.cl"
        >
          <i className="ri-mail-line text-red-500 text-2xl"></i>
        </a>
      </div>

      {/* WhatsApp Button */}
      <div className="flex items-center gap-3">
        {hoveredWa && (
          <div className="bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-full shadow-lg whitespace-nowrap">
            ¡Escríbenos ahora!
          </div>
        )}
        <a
          href="https://wa.me/56992265118?text=Hola%2C%20me%20interesa%20solicitar%20una%20cotizaci%C3%B3n%20para%20un%20proyecto"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-200 animate-pulse-slow cursor-pointer"
          onMouseEnter={() => setHoveredWa(true)}
          onMouseLeave={() => setHoveredWa(false)}
          aria-label="Contactar por WhatsApp"
        >
          <i className="ri-whatsapp-line text-white text-2xl"></i>
        </a>
      </div>
    </div>
  );
};

export default WhatsAppButton;
